export enum YandexAddressType {
  country = 'country',
  locality = 'locality',
  district = 'district',
  street = 'street',
  house = 'house',
  province = 'province',
  city = 'city',
}
